import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getAssetFeatureListSaga = createAction(
  "GET_ASSET_FEATURE",
  ({ payload, params }: SagaActionParams<Type.AssetFeatureDto[]>) => ({
    payload,
    url: "/api/admin/adminfeature" + (params ? params : ""),
  })
);
export const getAssetFeatureDetailsSaga = createAction(
  "GET_ASSET_FEATURE_DETAILS",
  ({ payload, id }: SagaActionParams<Type.AssetFeatureDetailDto>) => ({
    payload,
    url: "/api/admin/adminfeature/" + id,
  })
);
export const createAssetFeatureSaga = createAction(
  "CREATE_ASSET_FEATURE",
  ({ payload, body }: SagaActionParams<Type.AssetFeatureDto>) => ({
    payload,
    url: "/api/admin/adminfeature",
    body,
  })
);
export const updateAssetFeatureSaga = createAction(
  "UPDATE_ASSET_FEATURE",
  ({ payload, id, body }: SagaActionParams<Type.AssetFeatureDto>) => ({
    payload,
    url: "/api/admin/adminfeature/" + id,
    body,
  })
);
export const deleteAssetFeatureSaga = createAction(
  "DELETE_ASSET_FEATURE",
  ({ payload, id }: SagaActionParams<Type.AssetFeatureDto>) => ({
    payload,
    url: "/api/admin/adminfeature/" + id,
  })
);

const assetfeaturesSaga = [
  takeLatest<any>(
    getAssetFeatureListSaga.toString(),
    (payload: SagaGenericParams<Type.AssetFeatureDto[]>) =>
      getSaga<Type.AssetFeatureDto[]>(payload)
  ),
  takeLatest<any>(
    getAssetFeatureDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.AssetFeatureDetailDto>) =>
      getSaga<Type.AssetFeatureDetailDto>(payload)
  ),
  takeLatest<any>(
    createAssetFeatureSaga.toString(),
    (payload: SagaGenericParams<Type.AssetFeatureDto>) =>
      postSaga<Type.AssetFeatureDto>(payload)
  ),
  takeLatest<any>(
    updateAssetFeatureSaga.toString(),
    (payload: SagaGenericParams<Type.AssetFeatureDto>) =>
      putSaga<Type.AssetFeatureDto>(payload)
  ),
  takeLatest<any>(
    deleteAssetFeatureSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.AssetFeatureDto>(payload)
  ),
];

export default assetfeaturesSaga;
